export default "__VITE_ASSET__04ccddcc__"